import { render } from "./ChangelogEntry.vue?vue&type=template&id=499031c2&scoped=true"
import script from "./ChangelogEntry.vue?vue&type=script&lang=js"
export * from "./ChangelogEntry.vue?vue&type=script&lang=js"

import "./ChangelogEntry.vue?vue&type=style&index=0&id=499031c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499031c2"]])

export default __exports__